import {Component} from "react"

export default class Logo extends Component<any> {
    render() {
        return (
            <div className="logo-container">
				<a href="/" className="logo-link">
                	<img src="/homeindex_logo.svg" alt="" className="logo" aria-hidden />
				</a>
            </div>
        )
    }
}